import React, { useContext } from 'react'
import './Trip.css';
// import moment from 'moment';
import { useTranslation } from 'react-i18next';
import DataContext from '../../context/Datacontext';
import { useNavigate } from 'react-router-dom';
const Trip = ({trip}) => {
    // const { dateTime } = trip.date;
    // const momentObj = moment(dateTime);
    const navigate = useNavigate();
    const dateTime = new Date(trip?.date);
    // const dateTime = trip?.date;

    // const dateTime = new Date();
    // console.log(dateTime)
    // const date = dateTime.format('YYYY-MM-DD');
    // const day = dateTime.format('dddd');
    // const time = dateTime.format('HH:mm:ss');
    const year = dateTime?.getFullYear();
    const month = String(dateTime?.getMonth() + 1).padStart(2, '0');
    const day = String(dateTime?.getDate()).padStart(2, '0');
    const hours = String(dateTime?.getHours()).padStart(2, '0');
    const minutes = String(dateTime?.getMinutes()).padStart(2, '0');
    const seconds = String(dateTime?.getSeconds()).padStart(2, '0');

    const formattedDate = `${year}-${month}-${day}`;
    const formattedTime = `${hours}:${minutes}:${seconds}`;

    const dayOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const formattedDay = dayOfWeek[dateTime?.getDay()];

    const [t] = useTranslation("global");
    const {lang,setSelectedTrip} = useContext(DataContext);
    let fromser = '' , toser ='' , dayser = ''
    switch (trip?.from){
        case 'Damascus':
            fromser = `${t("search.Damascus")}`
            break;
        case 'Hama':
            fromser = `${t("search.Hama")}`
            break;
        case 'Alepo':
            fromser = `${t("search.Aleppo")}`
            break;
        case 'Homs':
            fromser = `${t("search.Homs")}`
            break;
        case 'Latakia':
            fromser = `${t("search.Latakia")}`
            break;
        case 'Tartous':
            fromser = `${t("search.Tartous")}`
            break;
        case 'Quneitra':
            fromser = `${t("search.Quneitra")}`
            break;     
        default:
            break;                                                                           
        }
    switch (trip?.to){
        case 'Damascus':
            toser = `${t("search.Damascus")}`
            break;
        case 'Hama':
            toser = `${t("search.Hama")}`
            break;
        case 'Alepo':
            toser = `${t("search.Aleppo")}`
            break;
        case 'Homs':
            toser = `${t("search.Homs")}`
            break;
        case 'Latakia':
            toser = `${t("search.Latakia")}`
            break;
        case 'Tartous':
            toser = `${t("search.Tartous")}`
            break;
        case 'Quneitra':
            toser = `${t("search.Quneitra")}`
            break;     
        default:
            break;                                                                           
        }
    switch (formattedDay){
        case 'Sunday':
            dayser = `${t("trip.Sunday")}`
            break;
        case 'Monday':
            dayser = `${t("trip.Monday")}`
            break;
        case 'Tuesday':
            dayser = `${t("trip.Tuesday")}`
            break;
        case 'Wednesday':
            dayser = `${t("trip.Wednesday")}`
            break;
        case 'Thursday':
            dayser = `${t("trip.Thursday")}`
            break;
        case 'Friday':
            dayser = `${t("trip.Friday")}`
            break;
        case 'Saturday':
            dayser = `${t("trip.Saturday")}`
            break;     
        default:
            break;                                                                           
        }
  return (
    <div className='trip_main' style={{cursor:'pointer'}} onClick={()=>{
        setSelectedTrip(trip);navigate('/selectedtrip');
    }}>
        <div className='trip_div1'>
            {trip.id}
        </div>
        <div className='trip_div2'>
            <p style={{fontWeight:'bold'}}>{trip?.companyName}</p>
        </div>

        <div className='trip_div3'>
            <div className='trip_h2' style={{flexDirection:lang?'row-reverse':'row'}}>
                <p className='trip_para'>{t("trip.from")}</p>
                <span className='trip_para'>:</span>
                <p className='trip_para'>{fromser}</p>
            </div>
            <div className='trip_h2' style={{flexDirection:lang?'row-reverse':'row'}}>
                <p className='trip_para'>{t("trip.to")}</p>
                <span className='trip_para'>:</span>
                <p className='trip_para'>{toser}</p>
            </div>
            <div className='trip_h2' style={{flexDirection:lang?'row-reverse':'row'}}>
                <p className='trip_para'>{t("trip.busnumber")}</p>
                <span className='trip_para'>:</span>
                <p className='trip_para'>{trip.bus?.numberOfBus}</p>
            </div>
            <div className='trip_h2' style={{flexDirection:lang?'row-reverse':'row'}}>
                <p className='trip_para'>{t("trip.bustype")}</p>
                <span className='trip_para'>:</span>
                <p className='trip_para'>{trip.bus?.type}</p>
            </div>
            <div className='trip_h2' style={{flexDirection:lang?'row-reverse':'row'}}>
                <p className='trip_para'>{t("trip.numberofseats")} </p>
                <span className='trip_para'>:</span>
                <p className='trip_para'>{trip.bus?.numOfSets}</p>
            </div>
            {/* <p className='trip_para'>Driver Name : {trip.bus.driverName}</p>
            <p className='trip_para'>Driver Assist : {trip.bus.helpDriverName}</p> */}
        </div>
        {/* <div className='trip_div4'>

        </div> */}
        <div className='trip_div5'>
            <div className='trip_h2' style={{flexDirection:lang?'row-reverse':'row'}}>
                <p className='trip_para'>{t("trip.day")} </p>
                <span className='trip_para'>:</span>
                <p className='trip_para'>{dayser}</p>
            </div>
            <p>{t("trip.date")} : {formattedDate}</p>
            <p style={{marginTop:'5px'}}>{t("trip.time")} : {formattedTime}</p>
            <div className='trip_h2' style={{flexDirection:lang?'row-reverse':'row'}}>
                <p className='trip_para'>{t("trip.price")} </p>
                <span className='trip_para'>:</span>
                <p className='trip_para'>{trip?.ticktPrice}</p>
                {/* <span className='trip_para'>{t("trip.sp")}</span> */}

            </div>
        </div>
        {/* <p>{trip.bus.id}</p> */}

    </div>
  )
}

export default Trip